let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9KCot")).then(() => parcelRequire('lfW1S'));